import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ProductRoutingModule } from './product-routing.module';
import { ProductListComponent } from './product-list/product-list.component';
import { ProductListDetailComponent } from './product-list-detail/product-list-detail.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {DropdownModule} from 'primeng/dropdown';
import {ModalModule} from 'ngx-bootstrap/modal';
import {CoreModule} from '../../core/core.module';
import {TranslateModule} from '@ngx-translate/core';
import {MultiSelectModule} from "primeng/multiselect";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        DropdownModule,
        ProductRoutingModule,
        NgbModule,
        ModalModule.forRoot(),
        CoreModule,
        TranslateModule,
        MultiSelectModule
    ],
  declarations: [
    ProductListComponent,
    ProductListDetailComponent
  ]
})
export class ProductModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/product/product.module.ts